import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview", "fileName", "removeButton"]

  connect() {
    this.inputTarget.addEventListener("change", this.handleFileSelect.bind(this))
  }

  handleFileSelect(event) {
    const file = event.target.files[0]

    if (file) {
      this.showPreview(file)
    } else {
      this.hidePreview()
    }
  }

  showPreview(file) {
    // Show the preview container
    this.previewTarget.classList.remove("hidden")

    // Update file name
    this.fileNameTarget.textContent = file.name

    // If it's an image, show a thumbnail
    if (file.type.startsWith("image/")) {
      const reader = new FileReader()
      reader.onload = (e) => {
        const img = this.previewTarget.querySelector("img")
        if (img) {
          img.src = e.target.result
          img.classList.remove("hidden")
        }
      }
      reader.readAsDataURL(file)
    }
  }

  hidePreview() {
    this.previewTarget.classList.add("hidden")
    const img = this.previewTarget.querySelector("img")
    if (img) {
      img.classList.add("hidden")
      img.src = ""
    }
  }

  remove(event) {
    event.preventDefault()
    this.inputTarget.value = ""
    this.hidePreview()
  }
}
